import { render, staticRenderFns } from "./CuentaCorriente.vue?vue&type=template&id=685bcb22&scoped=true&"
import script from "./CuentaCorriente.vue?vue&type=script&lang=js&"
export * from "./CuentaCorriente.vue?vue&type=script&lang=js&"
import style0 from "./CuentaCorriente.vue?vue&type=style&index=0&id=685bcb22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685bcb22",
  null
  
)

export default component.exports